import React from "react";
import NavBar from "../components/homePage/navBar";
import Warehouses from "../components/warehouses/Warehouses";
const WarehousesPage: React.FC = () => {
  return (
    <div>
      <NavBar />
      <Warehouses />
    </div>
  );
};

export default WarehousesPage;
